/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Unknown_VenueInputs */

const cs_settings_teams_unknown_venue = /** @type {(inputs: Settings_Teams_Unknown_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámá pobočka`)
};

const en_settings_teams_unknown_venue = /** @type {(inputs: Settings_Teams_Unknown_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown branch`)
};

/**
* | output |
* | --- |
* | "Unknown branch" |
*
* @param {Settings_Teams_Unknown_VenueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_unknown_venue = /** @type {((inputs?: Settings_Teams_Unknown_VenueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Unknown_VenueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_unknown_venue(inputs)
	return cs_settings_teams_unknown_venue(inputs)
});